import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({
  name: 'userProfilePhoto'
})
export class UserProfilePhotoPipe implements PipeTransform {
  private readonly basePath: string;
  private readonly fallbackImage: string;

  constructor() {
    const rawBasePath = environment.basePath || 'http://localhost:9000/';
    // Normalize: ensure exactly one trailing slash so joins are predictable.
    this.basePath = rawBasePath.replace(/\/+$/, '') + '/';
    // App-absolute asset path
    this.fallbackImage = 'assets/default-user.jpg';
  }

  transform(photoUrl?: string | null, fallbackImage?: string): string {
    const fallback = (fallbackImage && fallbackImage.trim()) ? fallbackImage.trim() : this.fallbackImage;
    const value = (photoUrl ?? '').toString().trim();

    if (!value) {
      return fallback;
    }

    // Common "invalid" sentinel values we see from APIs / forms
    if (
      value === 'null' ||
      value === 'undefined' ||
      value === 'NA' ||
      value === 'N/A'
    ) {
      return fallback;
    }

    // Already usable URLs
    if (/^(https?:)?\/\//i.test(value) || /^data:/i.test(value) || /^blob:/i.test(value)) {
      return value;
    }

    // App assets should pass through untouched
    if (value.startsWith('assets/') || value.startsWith('/assets/')) {
      return value.startsWith('/') ? value.slice(1) : value;
    }

    // If backend returns something like "uploads/....png" or "/uploads/....png",
    // prefix environment.basePath.
    const relative = value.replace(/^\/+/, ''); // remove leading slashes
    if (relative.startsWith('uploads/') || relative.startsWith('upload/')) {
      return `${this.basePath}${relative}`;
    }

    // Any other relative path: still treat as server-hosted
    // e.g. "public/..", "images/..", etc.
    if (!/^[a-zA-Z]:[\\/]/.test(relative)) {
      return `${this.basePath}${relative}`;
    }

    // Fallback for unexpected formats
    return fallback;
  }
}

